export const DARK_THEME = 'DARK_THEME';
export const LIGHT_THEME = 'LIGHT_THEME';
export const LIGHT_BG_COLOR = '#F7F8F9';
export const LIGHT_COLOR = '#ffffff';
export const DARK_COLOR = '#333649';
